import { request } from "@/utils/api-request";
import httpClient from "@/utils/http-client";

export function getBaAiReportList(params) {
  const url = "/admin/ba/mine/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getBaAiReportInfo(params) {
  const url = "/admin/ba/mine/info";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getBeusAiReportList(params) {
  const url = "/admin/beus/mine/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getBeusAiReportInfo(params) {
  const url = "/admin/beus/mine/info";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getGeoAiReportList(params) {
  const url = "/admin/geo/mine/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getGeoAiReportInfo(params) {
  const url = "/admin/geo/mine/info";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function insertGeoAiReportContent(params) {
  return submitGeoAiReportContent("/admin/geo/mine/content/insert", params);
}

export function updateGeoAiReportContent(params) {
  return submitGeoAiReportContent("/admin/geo/mine/content/update", params);
}

export function deleteGeoAiReportContent(params) {
  const url = "/admin/geo/mine/content/delete";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

function submitGeoAiReportContent(url, params) {
  const formData = new FormData();
  if (params.aid) {
    formData.append("aid", params.aid);
  }
  formData.append("type", params.type);
  formData.append("lang", params.lang);
  formData.append("isMini", params.isMini ? "true" : "false");
  formData.append("vol", params.vol);
  if (params.regDate) {
    formData.append("regDate", params.regDate);
  }
  formData.append("title", params.title);
  formData.append("bannerTitle", params.bannerTitle);
  formData.append("desc", JSON.stringify(params.desc));
  formData.append("tagList", JSON.stringify(params.tagList));
  formData.append("htmlFile", params.htmlFile);
  if (params.pdfFile) {
    formData.append("pdfFile", params.pdfFile);
  }

  return httpClient({
    method: "post",
    url,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((response) => response.data);
}
